// AreasPresentationSkeleton

/** MUI */
import { alpha, Card, CardHeader, CardContent, Skeleton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    skeleton: {
        backgroundColor: alpha(theme.palette.primary.light, 0.25),
    },
}));

const SectionsSkeleton = () => {
    const classes = useStyles();
    return (
        <Card
            sx={{
                "&": (theme) => ({
                    ...theme.shape.boxedWrapper,
                    borderRadius: "6px",
                    p: 1,
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                }),
                minHeight: 51,
            }}
        >
            <CardHeader
                action={
                    <Skeleton
                        // animation="wave"
                        variant="circular"
                        width={16}
                        height={16}
                        className={classes.skeleton}
                        sx={{ mt: 0.5, mr: 1 }}
                    />
                }
                title={
                    <Skeleton
                        // animation="wave"
                        height={8}
                        width="calc(100% - 24px)"
                        className={classes.skeleton}
                        variant="rectangular"
                    />
                }
                sx={{ py: 0.675, width: "100%" }}
            />
        </Card>
    );
};

export default SectionsSkeleton;
